import { render, staticRenderFns } from "./weekly-view-takeoff-boq.vue?vue&type=template&id=268d2f6d&scoped=true"
import script from "./weekly-view-takeoff-boq.vue?vue&type=script&lang=js"
export * from "./weekly-view-takeoff-boq.vue?vue&type=script&lang=js"
import style0 from "./weekly-view-takeoff-boq.vue?vue&type=style&index=0&id=268d2f6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268d2f6d",
  null
  
)

export default component.exports